import React, { useState, useContext } from "react";
import { FormGroup, Button, Input, FormFeedback, Container } from "reactstrap";
import { BottomSheet } from "react-spring-bottom-sheet";
import { AppContext } from "../../../context/app-context";
import API from "../../../helper/API";
import CodeActivationHeader from "./CodeActivationHeader";
import closeImg from "./close.svg";
import { useNavigate } from "react-router-dom";
import { needHelpEmailWeb, sendFirebaseEvent } from "../../../helper/mobile";
import bottomSheetImg from "./bottomsheet-img.png";

const CodeActivation = () => {
  let navigate = useNavigate();
  const [state, dispatch] = useContext(AppContext);
  const [open, setOpen] = useState(false);
  const [code, setCode] = useState();
  const [errorMessage, setErrorMessage] = useState("");
  const [errorConflict, setErrorConflict] = useState("");
  const [isDisabled, setIsDisabled] = useState(true);

  const handleChange = (e) => {
    const value = e.target.value.toLowerCase();
    const valueTrim = value.trim();

    if (valueTrim.length === 6) setIsDisabled(false);
    else setIsDisabled(true);

    if (valueTrim.length > 6) {
      setErrorMessage("Exceeded the maximum number of characters");
      setIsDisabled(false);
    } else {
      setCode(valueTrim);
      setErrorMessage("");
    }
  };

  const onClickButtonHandler = () => {
    sendFirebaseEvent("dp_activate_plan_btn", "click_event");
    if (state?.user) {
      const codeBody = {
        activationCode: code.trim(),
        userId: state.user.id,
        groupId: state.user.id,
        appVersion: state.user.appVersion,
        osType: state.user.osType,      
      };
      // https://develop-api.drtrust360.com/v2/banners?appVersion=9.9.9-dev&appVersionCode=999&osType=android&userId=f196d0d8-8550-4741-80cf-999b6fc01dd6&groupId=

      API.post(`/user/activation-code/verify`, codeBody)
        .then(function (response) {
          if (response?.data?.dietPlanData) {
            const dp = response.data.dietPlanData;
            let title = "",
              description = "";
            if (dp.dietPlanType === "one_month_smart_diet_plan") {
              title = "Welcome to the AI Diet plan";
              description =
                "You just took your first step to better health. Let’s get to know more about what you are trying to achieve next";
            } else {
              title = "Welcome to Diet 360";
              description =
                "You just took your first step to better health. Let’s get to know more about what you are trying to achieve next";
            }
            dispatch({
              type: "USER_DETAILS",
              payload: { dietPlanId: response.data.dietPlanData.dietPlanId },
            });
            dispatch({
              type: "COUPON_CODE_DIETPLAN",
              payload: { ...response.data.dietPlanData },
            });
            dispatch({
              type: "EXISTING_DIETPLAN",
              payload: { ...response.data.dietPlanData },
            });
            dispatch({
              type: "INFO_SCREEN",
              payload: {
                title: title,
                description: description,
                btnText: "Get started",
              },
            });
            navigate(`/dietPlan/infoScreen/true`);
          }
          document.body.classList.remove("loading-indicator");
        })
        .catch(function (error) {
          if (error?.response?.data) {
            if (error.response.status === 409) {
              setOpen(true);
              setErrorConflict(error.response.data.message);
            } else {
              setErrorMessage(error.response.data.message);
            }
          }
          document.body.classList.remove("loading-indicator");
        });
    }
  };

  const onClickNeedHelpHandler = () => {
    sendFirebaseEvent("dp_need_help_link", "click_event");
    needHelpEmailWeb();
  };

  return (
    <div>
      <CodeActivationHeader />
      <Container className="mt-5">
        <FormGroup>
          <Input
            invalid={errorMessage.length > 0 ? true : false}
            type="email"
            onChange={handleChange}
            className="text-center text-lowercase"
            placeholder="Enter code (For e.g. kgmdnr)"
            value={code}
          />
          <FormFeedback className="text-center">{errorMessage}</FormFeedback>
        </FormGroup>
      </Container>
      <div className="fix-div-button-question-flex">
        <div className="">
          <div className="need-help-link text-center mb-4">
            <span onClick={onClickNeedHelpHandler}>Need help?</span>
          </div>
          <div className="ps-3 pe-3">
            <Button
              className="risk-btn mb-4"
              disabled={isDisabled}
              onClick={onClickButtonHandler}
            >
              Activate my plan
            </Button>
          </div>
          <div className="risk-question-footer">
            <p className="mb-0 text-center">
              Please note your plan will start from the moment you activate your
              plan.
            </p>
          </div>
        </div>
      </div>
      <BottomSheet open={open} onDismiss={() => setOpen(false)}>
        <div className="ac-alredy-error p-4">
          <h3 className="mb-3">
            A plan is already active{" "}
            <span className="float-end" onClick={() => setOpen(false)}>
              <img src={closeImg} alt="" />
            </span>
          </h3>
          <img src={bottomSheetImg} className="w-100 mb-3" />
          <p className="mb-4 text-center">{errorConflict}</p>
          {/* <p className="mb-4 text-center">
            You can only have 1 active plan at a time. Your current plan ends on
            23 Jun 2021.
          </p> */}
          <Button className="risk-btn mb-1" onClick={() => setOpen(false)}>
            Okay
          </Button>
        </div>
      </BottomSheet>
    </div>
  );
};

export default CodeActivation;
